<field-float-readonly *ngIf="field.readonly; else editable" [field]="field"></field-float-readonly>
<ng-template #editable>
  <field-float-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-float-single>
</ng-template>
